export class PremierServiceExecutionDTO{
    public serviceConfigurationId!: number;
    public startedAt!: string;
    public finishedAt!: string;
    public configurationName!: string;
    public productName!: string;
    public customerId!: number;
    public clientId!: number;
    public status!: number; //1=In process, 2=Success, 3=Error
    public message!: string;
    public remarks!: string;
    public recurring!: boolean;
    public optionalParameters!: string;
    public addedByUserId!: number;
    public referenceValues!: string;
}